import { render, staticRenderFns } from "./BaseTabs.vue?vue&type=template&id=c33c1878&scoped=true&"
import script from "./BaseTabs.vue?vue&type=script&lang=js&"
export * from "./BaseTabs.vue?vue&type=script&lang=js&"
import style0 from "./BaseTabs.vue?vue&type=style&index=0&id=c33c1878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33c1878",
  null
  
)

component.options.__file = "BaseTabs.vue"
export default component.exports